import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

interface TicketLogSuccessfulProps {
    ticketPhrase: string;
    ticketId: number;
    open: boolean;
    onClose: () => void;
    webBaseUrl: string; // e.g., "https://helpdesk.example.com/tickets/"
}

const TicketLogSuccessful: React.FC<TicketLogSuccessfulProps> = ({
    ticketId,
    open,
    onClose,
    webBaseUrl,
    ticketPhrase,
}) => {
    const ticketUrl = `${webBaseUrl}/calls/callhistory.aspx?call_id=${ticketId}&from=teams`;

    return (
        <Dialog title={`${ticketPhrase} Logged Successfully`} onClose={onClose}  >
            <div>
                {ticketPhrase} <a href={ticketUrl} target="_blank" rel="noopener noreferrer">{ticketId}</a> has been logged successfully.
            </div>
            <DialogActionsBar>
                <Button themeColor="primary" onClick={onClose}>
                    OK
                </Button>
            </DialogActionsBar>
        </Dialog>
    );
};

export default TicketLogSuccessful;